import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteLayout } from "@/components/site/layout";
import { Reveal } from "@/components/site/reveal";
import { localBusinessJsonLd } from "@/components/site/jsonld";
import { listPublishedArticles } from "@/lib/synlig";
import { SITE } from "@/lib/site";

const TITLE = "Blogg | Drammen Car Wash";
const DESC = "Tips og guider om bilvask, bilpleie, dekkskift og oljeskift fra Drammen Car Wash.";

export const Route = createFileRoute("/blogg/")({
  loader: async () => listPublishedArticles(),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: `${SITE.url}/blogg` },
    ],
    links: [{ rel: "canonical", href: `${SITE.url}/blogg` }],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(localBusinessJsonLd()) }],
  }),
  component: BloggIndex,
});

function BloggIndex() {
  const articles = Route.useLoaderData();

  return (
    <SiteLayout>
      <section className="pt-32 pb-16 sm:pt-40 sm:pb-20">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-10 text-center">
          <Reveal>
            <div className="eyebrow">Blogg</div>
            <h1 className="mt-4 font-serif text-4xl sm:text-5xl md:text-6xl text-balance">
              Tips og guider
            </h1>
            <p className="mt-4 text-muted-foreground max-w-xl mx-auto">
              Bilvask og bilpleie i Drammen, fra teamet hos {SITE.name}.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 sm:pb-28 md:pb-40">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-10">
          {articles.length === 0 && (
            <p className="text-muted-foreground text-center">Ingen artikler publisert enda.</p>
          )}
          <div className="space-y-5">
            {articles.map((article) => (
              <Reveal key={article.id}>
                <Link
                  to="/blogg/$slug"
                  params={{ slug: article.slug }}
                  className="block rounded-2xl border border-border bg-card p-6 transition-colors hover:border-primary/40"
                >
                  <h2 className="font-serif text-xl">{article.title}</h2>
                  {article.meta_description && (
                    <p className="mt-2 text-sm text-muted-foreground">{article.meta_description}</p>
                  )}
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
